import reducer from "./reducers";

import * as encountersAction from "./actions";

export { encountersAction };

export default reducer;
